angular.module("ainapp")
    .controller("reconcileVouchersController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Reconcile Vouchers";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.init = function () {

                $scope.ViewVal = 13;
                $scope.SelectedVoucher = "Sales Invocie";
                $scope.VoucherList = [];
                $scope.selectAll = {
                    value: false
                };

                $scope.filter = {
                    FromDate: new Date(),
                    ToDate: new Date(),
                    FromDateString: "",
                    ToDateString: "",
                }

            }
            $scope.init();


            $scope.switchTab = function (id, type) {
                $scope.ViewVal = id;
                $scope.SelectedVoucher = type;
                $scope.VoucherList = [];
                $scope.selectAll.value = false;
            }

            $scope.selectAllVouchers = function () {

                if ($scope.selectAll.value == false) {
                    angular.forEach($scope.VoucherList, function (e) {
                        e.IsSelected = false;
                    })
                } else {
                    angular.forEach($scope.VoucherList, function (e) {
                        e.IsSelected = true;
                    })
                }
            }

            $scope.FilterData = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.selectAll.value = false;
                $scope.filter.FromDateString = $scope.extractDate($scope.filter.FromDate);
                $scope.filter.ToDateString = $scope.extractDate($scope.filter.ToDate);

                MainService.SalesInvoiceInReconcile($scope.filter).then(function (response) {
                    if (response.data) {
                        $scope.VoucherList = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })
            }



            $scope.processReconcile = function () {
                var tt = 1;
                var ttt = 0;
                var Vouchers = [];
                angular.forEach($scope.VoucherList, function (e) {
                    if (e.IsSelected) {
                        Vouchers.push(e);
                    }
                })
                $scope.processReconcile2(Vouchers, tt, ttt);
            }

            $scope.processReconcile2 = function (Vouchers, tt, ttt) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                var voucher = Vouchers[ttt];
                MainService.ReconcileVoucher(voucher.Id).then(function (response) {
                    if (response.data) {
                        if (Vouchers.length == tt) {
                            toastr.success("Success");
                        } else {

                            tt = tt + 1;
                            ttt = ttt + 1;

                            $scope.processReconcile2(Vouchers, tt, ttt);
                        }

                    } else {
                        $scope.Load = false;
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });

            }



            }])
